(function (root) {
  var DAY_MS = 24 * 60 * 60 * 1000;
  var collections = [
    { handle: 'suit-sets-for-women', title: 'Suit Sets for Women', count: 250, indices: [0, 1, 2, 5, 6] },
    { handle: 'kurtas', title: 'Kurtas', count: 65, indices: [2, 4, 6, 0] },
    { handle: 'dresses', title: 'Dresses', count: 131, indices: [3, 7] },
    { handle: 'suit-set', title: 'Suit Set', count: 169, indices: [1, 5, 0, 6] }
  ];
  root.RangelleRules = {
    collections: collections,
    homepageLimit: 20,
    remainingSeconds: function (now) {
      return Math.ceil((DAY_MS - ((now % DAY_MS + DAY_MS) % DAY_MS)) / 1000);
    },
    homepageItems: function (products, collection) {
      if (!products.length) return [];
      return Array.from({ length: 20 }, function (_, i) {
        return products[collection.indices[i % collection.indices.length] % products.length];
      });
    }
  };
})(typeof window === 'undefined' ? globalThis : window);